/* @flow */
const emailValidator = (email: String, informaOnly: Boolean) => {
  /* eslint-disable max-len */
  const regularExpression = {
    general: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    informa: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@informa.com$/,
  };
  /* eslint-enable max-len */

  const test = (e: String, re: Object) => {
    return re.test(e);
  };

  const validation = () => {
    switch (informaOnly) {
      case true:
        return test(email, regularExpression.informa);
      default:
        return test(email, regularExpression.general);
    }
  };

  const checkMail = validation();
  return checkMail;
};

export default emailValidator;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/enhancers/validators/emailValidator.js
 **/